import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getBusinessCompetencyTypes = async (projectId) => {
  const effectiveProjectId = projectId || 'user-competencies';

  // always returns competency types from on businesses. If projectId provided, returns also from business of given project.
  let apiPath = `cards/types/get-competency-types/${effectiveProjectId}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);

  return response.data;
};
